module.exports = __webpack_public_path__ + "static/img/16.ace33e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/16.png
// module id = GTTM
// module chunks = 35